<!-- <app-header></app-header> -->
<p-toast position="top-center"></p-toast>
<!-- <p-confirmDialog></p-confirmDialog> -->
<router-outlet />

<p-confirmdialog #cd [style]="{ width: '90vw', maxWidth: '500px' } ">
    <ng-template #headless let-message let-onAccept="onAccept" let-onReject="onReject">
        <div class="flex flex-col items-center p-6 bg-white rounded-lg shadow-lg 
                ">
            <div
                class="rounded-full bg-[var(--dark-blue)] text-white inline-flex justify-center items-center h-[146px] w-[146px] -mt-[100px]">
                <fa-icon *ngIf="message.icon == null" [icon]="faCircleQuestion" class="w-[66px] h-[66px] text-white mb-7 text-[66px]"></fa-icon>
                <fa-icon *ngIf="message.icon != null && message.icon == 'faCircleInfo'" [icon]="faCircleInfo" class="w-[66px] h-[66px] text-white mb-7 text-[66px]"></fa-icon>
            </div>

            <span class="font-bold text-xl block mb-2 mt-6 text-center">{{ message.header }}</span>
            <p class="mb-0 text-center text-gray-600"
                [innerHTML]="message.message   | sanitizeHtmlText">

            </p>

            <div class="flex items-center gap-4 mt-6 mb-[28px]">
                <button pButton type="button" [label]="message.acceptLabel != null ? message.acceptLabel : 'Remove'" (click)="onAccept()"
                    class="whitespace-nowrap h-[40px] rounded-2xl"
                    [ngClass]="{'w-1/2': message.rejectVisible == undefined || message!.rejectVisible == true,
                        'w-[130px]': message.rejectVisible != undefined && message!.rejectVisible == false
                    }">
                </button>

                <!-- Botón Cancel (Secondary) -->
                <button *ngIf="message.rejectVisible == undefined || message!.rejectVisible == true" pButton type="button" [label]="message.rejectLabel != null ? message.rejectLabel : 'Cancel'" (click)="onReject()" 
                class="w-1/2 whitespace-nowrap h-[40px] rounded-2xl border transition-colors"
                [outlined]="true">
                </button>
            </div>
        </div>
    </ng-template>
</p-confirmdialog>